module.exports = __webpack_public_path__ + "img/financial1.7491ccb4.svg";